module.exports = __webpack_public_path__ + "img/ico_rateStar.2b30da50.png";